import { useNavigation } from "@remix-run/react"
import { useEffect, type FC } from "react"
import nprogress from "nprogress"

const Loading: FC = () => {
  const transition = useNavigation()
  const active = transition.state != "idle"

  useEffect(() => {
    if (active) {
      nprogress.start()
    } else {
      nprogress.done()
    }
  }, [active])

  return null
}

export default Loading
